module.exports = __webpack_public_path__ + "img/annotation2.0c772b73.svg";